import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
    getNameDay,
    getTekDay,
    getTime,
} from 'src/app/components/application/global.function';
import { IHistoryEvents } from 'src/app/interfaces/history.interfaces';
import type { TPacsViewerAction } from 'src/app/interfaces/pacs-viewer.types';
import { DicomViewModalComponent } from '../../dicom-view-modal/dicom-view-modal.component';
import { lastValueFrom } from 'rxjs';
import { HttpNewService } from 'src/app/services/application/http-new.service';
import { SemdModalComponent } from 'src/app/modals/semd-modal/semd-modal.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'semd-view',
    templateUrl: './semd-view.component.html',
    styleUrls: ['./semd-view.component.scss'],
    standalone: false,
})
export class SemdViewComponent {
    @Input() public visit!: IHistoryEvents;
    public pdfImageURL = 'assets/icons/documents/pdf-view.svg';
    public showFilials = true;
    public pdfLoading = false;
    public constructor(
        private modalService: NgbModal,
        private http: HttpNewService,
        private sanitizer: DomSanitizer,
    ) {}

    protected async goPreview(id: number, tp: string, $event: MouseEvent) {
        $event.stopPropagation();
        this.pdfLoading = true;
        const res = await lastValueFrom(
            this.http.get<Array<string> | string>(
                `/history/events/item/semd?tp=${tp}&id=${id}&isNeedPdf=0&sort=0`,
            ),
        );
        const safeHtml = [];
        for (const part of res) {
            safeHtml.push(this.sanitizer.bypassSecurityTrustHtml(part));
        }
        const modal = this.modalService.open(SemdModalComponent, {
            size: 'large',
        });
        modal.componentInstance.data = safeHtml;
        this.pdfLoading = false;
    }

    protected async gotToDownload(id: number, tp: string, $event: MouseEvent) {
        $event.stopPropagation();
        this.pdfLoading = true;
        const res = await lastValueFrom(
            // Тут нужно посмотреть - на бэке обработано, что может вернуться и строка, и массив строк, тут ожидается все же только строка
            this.http.get<string>(
                `/history/events/item/semd?tp=${tp}&id=${id}&isNeedPdf=1&sort=0`,
            ),
        );
        this.pdfLoading = false;
        return this.printPdf(res);
    }

    protected openDicomModal(
        historyType: string,
        historyId: number,
        e: MouseEvent,
        action: TPacsViewerAction = 'VIEW',
    ) {
        e.stopPropagation();
        const modal = this.modalService.open(DicomViewModalComponent);
        modal.componentInstance.historyType = historyType;
        modal.componentInstance.historyId = historyId;
        modal.componentInstance.action = action;
    }

    protected getTekDay(dt: Date): string {
        return getTekDay(dt);
    }

    protected getTime(dt: Date): string {
        return getTime(dt);
    }

    protected getNameDay(dt: Date): string {
        return getNameDay(dt);
    }
    protected stopPropagation(e: MouseEvent) {
        e.stopPropagation();
    }
    private printPdf(blob: string): void {
        if (Array.isArray(blob)) blob = blob.join(';');
        const isHtml = blob.includes('<html') || blob.includes('<!DOCTYPE');
        if (!isHtml) {
            try {
                const cleanBase64 = blob.replace(
                    /^data:application\/pdf;base64,/,
                    '',
                );
                const binaryString = atob(cleanBase64);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                const file = new Blob([bytes], {
                    type: 'application/pdf',
                    endings: 'native',
                });
                const fileURL = URL.createObjectURL(file);
                const link = document.createElement('a');
                link.href = fileURL;
                link.type = 'application/pdf';
                link.download = 'document.pdf';
                link.rel = 'noopener noreferrer';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setTimeout(() => URL.revokeObjectURL(fileURL), 60_000);
            } catch (error) {
                console.error('Ошибка при обработке пдф', error);
                this.downloadHtml(blob);
            }
        } else {
            this.downloadHtml(blob);
        }
    }

    private downloadHtml(htmlContent: string): void {
        const blob = new Blob([htmlContent], {
            type: 'text/html;charset=utf-8',
        });
        this.downloadFile(blob, 'document.html');
    }
    private downloadFile(blob: Blob, fileName: string): void {
        const url = URL.createObjectURL(blob);

        if (this.isMobile()) {
            window.open(url, '_blank');
            setTimeout(() => URL.revokeObjectURL(url), 60000);
        } else {
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.rel = 'noopener noreferrer';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => URL.revokeObjectURL(url), 60000);
        }
    }

    private isMobile(): boolean {
        return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }
}
